export class ProduktionsomradeTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        produktionsomraden: "Produktionsområden",
        produktionsomrade: "Produktionsområde",
        resultatomrade: "Region",
        brytgransTitel: "Brytgränser för direktutbyte",
        voUppgifterTitel: "Uppgifter för virkesorder",
        granNedre: "Gran nedre",
        granOvre: "Gran övre",
        tallNedre: "Tall nedre",
        tallOvre: "Tall övre",
        internnummer: "Internnummer",
        namn: "Namn",
        adress1: "Adress 1",
        adress2: "Adress 2",
        postnummer: "Postnummer",
        postadress: "Postadress",
        mobilnummer: "Mobilnummer",
        telefonnummer: "Telefonnummer",
        lamnaModalHeader: "Osparade ändringar",
        lamnaModalBody: "Det finns osparade ändringar, vill du spara innan sidan lämnas?",
        raknaOmDirektutbyte: "Räkna om direktutbyte",
        sparaMessage: "Ändringarna har sparats",
        raknaOmDirektutbyteResponse: "Direktutbyte kommer att räknas om för {0} åtgärder. Exekveringen kan ta lång tid.",
        beraknaVinteravstand: "Beräkna vinteravstånd"
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static validation = {
        internnummer: "Internnummer måste vara 5 siffror",
        namn: "Namn får inte vara längre än 25 tecken.",
        adress: "Adress får inte vara längre än 25 tecken.",
        postnummer: "Postnummer får inte vara längre än 6 siffror.",
        postadress: "Postadress får inte vara längre än 20 tecken",
        mobilnummer: "Mobilnummer får inte vara längre än 12 siffror",
        telefonnummer: "Telefonnummer får inte vara längre än 12 siffror",
        granNedre: "Brytgräns gran nedre får inte vara större än övre",
        granOvre: "Brytgräns gran övre får inte vara mindre än nedre",
        tallNedre: "Brytgräns tall nedre får inte vara större än övre",
        tallOvre: "Brytgräns tall övre får inte vara mindre än nedre"
    };
}
